import {Action} from '@ngrx/store';
import {Pruefantwort, Pruefaufgabe, Pruefcheckliste, Pruefobjekt, Pruefplan} from '../../../clients/qschecks';

export const PAGE_STATE_RESET = '[QSChecksPage] Page State reset';

// Prüfpläne
export const PRUEFPLAENE_LADEN = '[QSChecksPage] Prüfpläne laden';
export const AKTUELLEN_PRUEFPLAN_SETZEN = '[QSChecksPage] Aktuellen Prüfplan setzen';
export const NEUER_PRUEFPLAN = '[QSChecksPage] Neuer Prüfplan';
export const PRUEFPLAN_LOESCHEN = '[QSChecksPage] Prüfplan löschen';
export const PRUEFPLAN_KOPIEREN = '[QSChecksPage] Prüfplan kopieren';
export const PRUEFPLAN_TITEL_SETZEN = '[QSChecksPage] Prüfplan Titel setzen';
export const PRUEFPLAN_BESCHREIBUNG_SETZEN = '[QSChecksPage] Prüfplan Beschreibung setzen';
export const PRUEFPLAN_IST_AKTIV_SETZEN = '[QSChecksPage] Prüfplan Ist Aktiv setzen';
export const PRUEFPLAN_ZAEHLER_PRO_V_TYP_SETZEN = '[QSChecksPage] Prüfplan Zähler pro Veranstaltungstyp setzen';
export const PRUEFPLAN_SPEICHERN = '[QSChecksPage] Prüfplan speichern';

// Prüfplan - Antworten
export const PRUEFPLAN_ANTWORTEN_LADEN = '[QSChecksPage] Prüfplan Antworten laden';
export const AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN = '[QSChecksPage] Aktuelle Prüfplan Antwort setzen';
export const PRUEFPLAN_ANTWORT_KUERZEL_SETZEN = '[QSChecksPage] Prüfplan Antwort Kürzel setzen';
export const PRUEFPLAN_ANTWORT_BESCHREIBUNG_SETZEN = '[QSChecksPage] Prüfplan Antwort Beschreibung setzen';
export const PRUEFPLAN_ANTWORT_GEWICHTUNG_SETZEN = '[QSChecksPage] Prüfplan Antwort Gewichtung setzen';
export const PRUEFPLAN_ANTWORT_FARBE_SETZEN = '[QSChecksPage] Prüfplan Antwort Farbe setzen';
export const PRUEFPLAN_ANTWORT_ICON_SETZEN = '[QSChecksPage] Prüfplan Antwort Icon setzen';
export const PRUEFPLAN_ANTWORT_IST_AKTIV_SETZEN = '[QSChecksPage] Prüfplan Antwort Ist Aktiv setzen';
export const PRUEFPLAN_ANTWORT_IST_NA_ANTWORT_SETZEN = '[QSChecksPage] Prüfplan Antwort Ist NA Antwort setzen';
export const PRUEFPLAN_ANTWORT_SPEICHERN = '[QSChecksPage] Prüfplan Antwort speichern';

// Prüfobjekte
export const PRUEFOBJEKTE_LADEN = '[QSChecksPage] Prüfobjekte laden';
export const AKTUELLES_PRUEFOBJEKT_SETZEN = '[QSChecksPage] Aktuelles Prüfobjekt setzen';
export const NEUES_PRUEFOBJEKT = '[QSChecksPage] Neues Prüfobjekt';
export const PRUEFOBJEKT_LOESCHEN = '[QSChecksPage] Prüfobjekt löschen';
export const PRUEFOBJEKT_KOPIEREN = '[QSChecksPage] Prüfobjekt kopieren';
export const PRUEFOBJEKT_TITEL_SETZEN = '[QSChecksPage] Prüfobjekt Titel setzen';
export const PRUEFOBJEKT_BESCHREIBUNG_SETZEN = '[QSChecksPage] Prüfobjekt Beschreibung setzen';
export const PRUEFOBJEKT_IST_AKTIV_SETZEN = '[QSChecksPage] Prüfobjekt Ist Aktiv setzen';
export const PRUEFOBJEKT_SPEICHERN = '[QSChecksPage] Prüfobjekt speichern';

// Prüf-Checklisten
export const PRUEF_CHECKLISTEN_LADEN = '[QSChecksPage] Prüf-Checklisten laden';
export const AKTUELLE_PRUEF_CHECKLISTE_SETZEN = '[QSChecksPage] Aktuelle Prüf-Checkliste setzen';
export const NEUE_PRUEF_CHECKLISTE = '[QSChecksPage] Neue Prüf-Checkliste';
export const PRUEF_CHECKLISTE_LOESCHEN = '[QSChecksPage] Prüf-Checkliste löschen';
export const PRUEF_CHECKLISTE_KOPIEREN = '[QSChecksPage] Prüf-Checkliste kopieren';
export const PRUEF_CHECKLISTE_TITEL_SETZEN = '[QSChecksPage] Prüf-Checkliste Titel setzen';
export const PRUEF_CHECKLISTE_BESCHREIBUNG_SETZEN = '[QSChecksPage] Prüf-Checkliste Beschreibung setzen';
export const PRUEF_CHECKLISTE_IST_AKTIV_SETZEN = '[QSChecksPage] Prüf-Checkliste Ist Aktiv setzen';
export const PRUEF_CHECKLISTE_SPEICHERN = '[QSChecksPage] Prüf-Checkliste speichern';

// Prüf-Aufgaben
export const PRUEF_AUFGABEN_LADEN = '[QSChecksPage] Prüf-Aufgaben laden';
export const AKTUELLE_PRUEF_AUFGABE_SETZEN = '[QSChecksPage] Aktuelle Prüf-Aufgabe setzen';
export const NEUE_PRUEF_AUFGABE = '[QSChecksPage] Neue Prüf-Aufgabe';
export const PRUEF_AUFGABE_LOESCHEN = '[QSChecksPage] Prüf-Aufgabe löschen';
export const PRUEF_AUFGABE_KOPIEREN = '[QSChecksPage] Prüf-Aufgabe kopieren';
export const PRUEF_AUFGABE_TITEL_SETZEN = '[QSChecksPage] Prüf-Aufgabe Titel setzen';
export const PRUEF_AUFGABE_BESCHREIBUNG_SETZEN = '[QSChecksPage] Prüf-Aufgabe Beschreibung setzen';
export const PRUEF_AUFGABE_GEWICHTUNG_SETZEN = '[QSChecksPage] Prüf-Aufgabe Gewichtung setzen';
export const PRUEF_AUFGABE_IST_AKTIV_SETZEN = '[QSChecksPage] Prüf-Aufgabe Ist Aktiv setzen';
export const PRUEF_AUFGABE_ANTWORT_IST_AKTIV_SETZEN = '[QSChecksPage] Prüf-Aufgabe Zulässige Antwort Ist Aktiv setzen';
export const PRUEF_AUFGABE_SPEICHERN = '[QSChecksPage] Prüf-Aufgabe speichern';

// Rollen/Berechtigungen
export const QS_PRUEFER_ROLLEN_LADEN = '[QSChecksPage] Qs-Prüfer-Rollen laden';
export const QS_PRUEFER_ROLLEN_SETZEN = '[QSChecksPage] QS-Prüfer-Rollen setzen';
export const QS_PRUEFER_ROLLEN_HINZUFUEGEN = '[QSChecksPage] QS-Prüfer-Rolle hinzufügen';
export const QS_PRUEFER_ROLLEN_LOESCHEN = '[QSChecksPage] QS-Prüfer-Rolle löschen';

export const QS_CONTROLLER_ROLLEN_LADEN = '[QSChecksPage] QS-Controller-Rollen laden';
export const QS_CONTROLLER_ROLLEN_SETZEN = '[QSChecksPage] QS-Controller-Rollen setzen';
export const QS_CONTROLLER_ROLLEN_HINZUFUEGEN = '[QSChecksPage] QS-Controller-Rolle hinzufügen';
export const QS_CONTROLLER_ROLLEN_LOESCHEN = '[QSChecksPage] QS-Controller-Rolle löschen';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// PRÜFPLÄNE
export class PruefplaeneLadenAction implements Action {
    readonly type = PRUEFPLAENE_LADEN;

    constructor() {
    }
}

export class AktuellenPruefplanSetzenAction implements Action {
    readonly type = AKTUELLEN_PRUEFPLAN_SETZEN;

    constructor(public payload: Pruefplan) {
    }
}

export class NeuerPruefplanAction implements Action {
    readonly type = NEUER_PRUEFPLAN;

    // Funktionsbereichsid
    constructor(public payload: string) {
    }
}

export class PruefplanLoeschenAction implements Action {
    readonly type = PRUEFPLAN_LOESCHEN;

    constructor() {
    }
}

export class PruefplanKopierenAction implements Action {
    readonly type = PRUEFPLAN_KOPIEREN;

    constructor() {
    }
}

export class PruefplanTitelSetzenAction implements Action {
    readonly type = PRUEFPLAN_TITEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanBeschreibungSetzenAction implements Action {
    readonly type = PRUEFPLAN_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanIstAktivSetzenAction implements Action {
    readonly type = PRUEFPLAN_IST_AKTIV_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefplanZahlerProVTypSetzenAction implements Action {
    readonly type = PRUEFPLAN_ZAEHLER_PRO_V_TYP_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefplanSpeichernAction implements Action {
    readonly type = PRUEFPLAN_SPEICHERN;

    constructor() {
    }
}

// PRÜFPLAN ANTWORTEN
export class PruefplanAntwortenLadenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORTEN_LADEN;

    constructor() {
    }
}

export class AktuellePruefplanAntwortSetzenAction implements Action {
    readonly type = AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN;

    constructor(public payload: Pruefantwort) {
    }
}

export class PruefplanAntwortKuerzelSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_KUERZEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanAntwortBeschreibungSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanAntwortGewichtungSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_GEWICHTUNG_SETZEN;

    constructor(public payload: number) {
    }
}

export class PruefplanAntwortFarbeSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_FARBE_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanAntwortIconSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_ICON_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefplanAntwortIstAktivSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_IST_AKTIV_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefplanAntwortIstNaAntwortSetzenAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_IST_NA_ANTWORT_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefplanAntwortSpeichernAction implements Action {
    readonly type = PRUEFPLAN_ANTWORT_SPEICHERN;

    constructor() {
    }
}

// Prüfobjekte
export class PruefobjekteLadenAction implements Action {
    readonly type = PRUEFOBJEKTE_LADEN;

    constructor() {
    }
}

export class AktuellesPruefobjektSetzenAction implements Action {
    readonly type = AKTUELLES_PRUEFOBJEKT_SETZEN;

    constructor(public payload: Pruefobjekt) {
    }
}

export class NeuesPruefobjektAction implements Action {
    readonly type = NEUES_PRUEFOBJEKT;

    constructor() {
    }
}

export class PruefobjektLoeschenAction implements Action {
    readonly type = PRUEFOBJEKT_LOESCHEN;

    constructor() {
    }
}

export class PruefobjektKopierenAction implements Action {
    readonly type = PRUEFOBJEKT_KOPIEREN;

    constructor() {
    }
}

export class PruefobjektTitelSetzenAction implements Action {
    readonly type = PRUEFOBJEKT_TITEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefobjektBeschreibungSetzenAction implements Action {
    readonly type = PRUEFOBJEKT_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefobjektIstAktivSetzenAction implements Action {
    readonly type = PRUEFOBJEKT_IST_AKTIV_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefobjektSpeichernAction implements Action {
    readonly type = PRUEFOBJEKT_SPEICHERN;

    constructor() {
    }
}


// Prüf-Checklisten
export class PruefChecklistenLadenAction implements Action {
    readonly type = PRUEF_CHECKLISTEN_LADEN;

    constructor() {
    }
}

export class AktuellePruefChecklisteSetzenAction implements Action {
    readonly type = AKTUELLE_PRUEF_CHECKLISTE_SETZEN;

    constructor(public payload: Pruefcheckliste) {
    }
}

export class NeuePruefChecklisteAction implements Action {
    readonly type = NEUE_PRUEF_CHECKLISTE;

    constructor() {
    }
}

export class PruefChecklisteLoeschenAction implements Action {
    readonly type = PRUEF_CHECKLISTE_LOESCHEN;

    constructor() {
    }
}

export class PruefChecklisteKopierenAction implements Action {
    readonly type = PRUEF_CHECKLISTE_KOPIEREN;

    constructor() {
    }
}

export class PruefChecklisteTitelSetzenAction implements Action {
    readonly type = PRUEF_CHECKLISTE_TITEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefChecklisteBeschreibungSetzenAction implements Action {
    readonly type = PRUEF_CHECKLISTE_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefChecklisteIstAktivSetzenAction implements Action {
    readonly type = PRUEF_CHECKLISTE_IST_AKTIV_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefChecklisteSpeichernAction implements Action {
    readonly type = PRUEF_CHECKLISTE_SPEICHERN;

    constructor() {
    }
}


// Prüf-Aufgaben
export class PruefAufgabenLadenAction implements Action {
    readonly type = PRUEF_AUFGABEN_LADEN;

    constructor() {
    }
}

export class AktuellePruefAufgabeSetzenAction implements Action {
    readonly type = AKTUELLE_PRUEF_AUFGABE_SETZEN;

    constructor(public payload: Pruefaufgabe) {
    }
}

export class NeuePruefAufgabeAction implements Action {
    readonly type = NEUE_PRUEF_AUFGABE;

    constructor() {
    }
}

export class PruefAufgabeLoeschenAction implements Action {
    readonly type = PRUEF_AUFGABE_LOESCHEN;

    constructor() {
    }
}

export class PruefAufgabeKopierenAction implements Action {
    readonly type = PRUEF_AUFGABE_KOPIEREN;

    constructor() {
    }
}

export class PruefAufgabeTitelSetzenAction implements Action {
    readonly type = PRUEF_AUFGABE_TITEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefAufgabeBeschreibungSetzenAction implements Action {
    readonly type = PRUEF_AUFGABE_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class PruefAufgabeGewichtungSetzenAction implements Action {
    readonly type = PRUEF_AUFGABE_GEWICHTUNG_SETZEN;

    constructor(public payload: number) {
    }
}

export class PruefAufgabeIstAktivSetzenAction implements Action {
    readonly type = PRUEF_AUFGABE_IST_AKTIV_SETZEN;

    constructor(public payload: boolean) {
    }
}

export class PruefAufgabeAntwortIstAktivSetzenAction implements Action {
    readonly type = PRUEF_AUFGABE_ANTWORT_IST_AKTIV_SETZEN;

    constructor(public payload: boolean, public pruefantwort: Pruefantwort) {
    }
}

export class PruefAufgabeSpeichernAction implements Action {
    readonly type = PRUEF_AUFGABE_SPEICHERN;

    constructor() {
    }
}


// Rollen/Berechtigungen
export class QsPrueferRollenLadenAction implements Action {
    readonly type = QS_PRUEFER_ROLLEN_LADEN;

    constructor() {
    }
}

export class QsPrueferRollenSetzenAction implements Action {
    readonly type = QS_PRUEFER_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}

export class QsPrueferRollenHinzufuegenAction implements Action {
    readonly type = QS_PRUEFER_ROLLEN_HINZUFUEGEN;

    constructor(public payload: Array<string>) {
    }
}

export class QsPrueferRollenLoeschenAction implements Action {
    readonly type = QS_PRUEFER_ROLLEN_LOESCHEN;

    constructor() {
    }
}

export class QsControllerRollenLadenAction implements Action {
    readonly type = QS_CONTROLLER_ROLLEN_LADEN;

    constructor() {
    }
}
export class QsControllerRollenSetzenAction implements Action {
    readonly type = QS_CONTROLLER_ROLLEN_SETZEN;

    constructor(public payload: Array<string>) {
    }
}

export class QsControllerRollenHinzufuegenAction implements Action {
    readonly type = QS_CONTROLLER_ROLLEN_HINZUFUEGEN;

    constructor(public payload: Array<string>) {
    }
}

export class QsControllerRollenLoeschenAction implements Action {
    readonly type = QS_CONTROLLER_ROLLEN_LOESCHEN;

    constructor() {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    PageStateResetAction
    | PruefplaeneLadenAction
    | AktuellenPruefplanSetzenAction
    | NeuerPruefplanAction
    | PruefplanLoeschenAction
    | PruefplanKopierenAction
    | PruefplanTitelSetzenAction
    | PruefplanBeschreibungSetzenAction
    | PruefplanIstAktivSetzenAction
    | PruefplanZahlerProVTypSetzenAction
    | PruefplanSpeichernAction

    | PruefplanAntwortenLadenAction
    | AktuellePruefplanAntwortSetzenAction
    | PruefplanAntwortKuerzelSetzenAction
    | PruefplanAntwortBeschreibungSetzenAction
    | PruefplanAntwortGewichtungSetzenAction
    | PruefplanAntwortFarbeSetzenAction
    | PruefplanAntwortIconSetzenAction
    | PruefplanAntwortIstAktivSetzenAction
    | PruefplanAntwortIstNaAntwortSetzenAction
    | PruefplanAntwortSpeichernAction

    | PruefobjekteLadenAction
    | AktuellesPruefobjektSetzenAction
    | NeuesPruefobjektAction
    | PruefobjektLoeschenAction
    | PruefobjektKopierenAction
    | PruefobjektTitelSetzenAction
    | PruefobjektBeschreibungSetzenAction
    | PruefobjektIstAktivSetzenAction
    | PruefobjektSpeichernAction

    | PruefChecklistenLadenAction
    | AktuellePruefChecklisteSetzenAction
    | NeuePruefChecklisteAction
    | PruefChecklisteLoeschenAction
    | PruefChecklisteKopierenAction
    | PruefChecklisteTitelSetzenAction
    | PruefChecklisteBeschreibungSetzenAction
    | PruefChecklisteIstAktivSetzenAction
    | PruefChecklisteSpeichernAction

    | PruefAufgabenLadenAction
    | AktuellePruefAufgabeSetzenAction
    | NeuePruefAufgabeAction
    | PruefAufgabeLoeschenAction
    | PruefAufgabeKopierenAction
    | PruefAufgabeTitelSetzenAction
    | PruefAufgabeBeschreibungSetzenAction
    | PruefAufgabeGewichtungSetzenAction
    | PruefAufgabeIstAktivSetzenAction
    | PruefAufgabeAntwortIstAktivSetzenAction
    | PruefAufgabeSpeichernAction

    | QsPrueferRollenLadenAction
    | QsPrueferRollenSetzenAction
    | QsPrueferRollenHinzufuegenAction
    | QsPrueferRollenLoeschenAction
    | QsControllerRollenLadenAction
    | QsControllerRollenSetzenAction
    | QsControllerRollenHinzufuegenAction
    | QsControllerRollenLoeschenAction
    ;
